<template>
  <component
    :is="component"
    :class="rootClass"
    v-bind="$attrs"
  >
    <slot />
  </component>
</template>

<script>

import defaultRootComponent from '../defaultRootComponent'

export default {
  name: 'Indicator',

  mixins: [
    defaultRootComponent('div')
  ],

  props: {
    active: Boolean
  },

  computed: {
    rootClass () {
      return [
        this.$style.root,
        { [ this.$style.active ]: this.active }
      ]
    }
  }
}

</script>

<style module>

.root {
  position: relative;
}

.root::before {
  content: '';
  position: absolute;
  top: -4px;
  right: -4px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  visibility: hidden;

  @apply bg-primary;
}

.root.active::before {
  visibility: visible;
}

</style>
